export const matchingApiPaths = <const>{
    getQBooksAccountLineItemMatchingSuggestions: 'companies/:companyId/matching/qbooks/suggestions/account-based-line',
    getQBooksLineItemMatchingSuggestions: 'companies/:companyId/matching/qbooks/suggestions/item-based-line',
};
